import { client } from '../client';

export const getConversationToken = async (): Promise<string> => {
  const { data } = await client.post(`/messages/access_token`, {});

  return data.access_token;
};
